var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._b({tag:"component",on:{"refresh":function($event){return _vm.$emit('refresh')},"perform":function (opts) { return _vm.$emit('perform', opts); }}},'component',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }